import * as React from "react";
const ReactModal = require('react-modal');
import PillFilter from "./pill-filter";
import Accordian from "../accordian";
import SearchField from "../search-field";
export default class MobileFilter extends React.Component {
    constructor(props) {
        super(props);
        this.toggle = () => {
            this.props.updateMobileToggle();
        };
        this.customStyle = {
            overlay: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.4)',
                zIndex: 1000,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            },
            content: {
                background: '#fff',
                overflow: 'auto',
                WebkitOverflowScrolling: 'touch',
                outline: 'none',
                padding: '20px',
                width: '85%',
                height: '100%',
            }
        };
        this.customClasses = {
            afterOpen: 'afterOpen',
            base: 'base mobile-filter-modal',
            beforeClose: 'beforeClose'
        };
        this.customOverlayClasses = {
            afterOpen: 'afterOpen',
            base: 'base',
            beforeClose: 'beforeClose'
        };
        this.customAriaVariables = {
            labelledby: 'labelledby',
            describedby: 'describedby'
        };
    }
    render() {
        const varietalList = this.props.VarietalList.length > 0 ? this.props.VarietalList.map((item, index) => {
            return React.createElement(SearchField, { key: index, selected: this.props.currentFilter.varietal
                    .split(',')
                    .includes(item), onClick: () => { this.props.updateSubFilter(item, "ConsumerVarietal"); }, label: item });
        }) : null;
        const typeList = this.props.categoryTypes.length > 0 ? this.props.categoryTypes.map((item, index) => {
            return React.createElement(SearchField, { key: index, selected: this.props.typeSelected === item, onClick: () => { this.props.changeTypes(item); }, label: item });
        }) : null;
        const countryList = this.props.CountryList.length > 0 ? this.props.CountryList.map((item, index) => {
            return React.createElement(SearchField, { key: index, selected: this.props.currentFilter.country
                    .split(',')
                    .includes(item.trim()), onClick: () => { this.props.updateSubFilter(item.trim(), "country"); }, label: item });
        }) : null;
        const regionList = this.props.RegionList.length > 0 ? this.props.RegionList.map((item, index) => {
            return React.createElement(SearchField, { key: index, selected: this.props.currentFilter.region
                    .split(',')
                    .includes(item.trim()), onClick: () => { this.props.updateSubFilter(item.trim(), "region"); }, label: item });
        }) : null;
        const vintageList = this.props.VintageList.length > 0 ? this.props.VintageList.map((item, index) => {
            return React.createElement(SearchField, { key: index, selected: this.props.currentFilter.vintage
                    .split(',')
                    .includes(item), onClick: () => { this.props.updateSubFilter(item, "vintage"); }, label: item });
        }) : null;
        const sortList = this.props.orderByOptions.length > 0 ? this.props.orderByOptions.map((item, index) => {
            return React.createElement(SearchField, { key: index, selected: this.props.currentOrderBy == item.value, onClick: () => { this.props.updateOrderBy(item.value); }, label: item.label });
        }) : null;
        const varietalAccord = this.props.VarietalList.length > 0 ? (React.createElement(Accordian, { header: "Varietal", content: React.createElement("div", { className: "acrd-list" }, varietalList) })) : null;
        const countryAccord = this.props.CountryList.length > 0 ? (React.createElement(Accordian, { header: "Country", content: React.createElement("div", { className: "acrd-list" }, countryList) })) : null;
        const regionAccord = this.props.RegionList.length > 0 ? (React.createElement(Accordian, { header: "Region", content: React.createElement("div", { className: "acrd-list" }, regionList) })) : null;
        const vintageAccord = this.props.VintageList.length > 0 ? (React.createElement(Accordian, { header: "Vintage", content: React.createElement("div", { className: "acrd-list" }, vintageList) })) : null;
        return (React.createElement(ReactModal, { isOpen: this.props.toggleMobile || false, onRequestClose: this.toggle, contentLabel: "filter label", style: this.customStyle, className: this.customClasses, overlayClassName: this.customOverlayClasses, bodyOpenClassName: 'bodyOpenClassName', aria: this.customAriaVariables },
            React.createElement("h2", { className: "filter-header", style: { display: "flex", alignItems: "center" } },
                "Filters",
                React.createElement("i", { className: "fa fa-times", style: { marginLeft: "auto", cursor: "pointer" }, onClick: this.toggle })),
            React.createElement("div", { className: "applied" },
                React.createElement(PillFilter, { currentFilter: this.props.currentFilter, updateSubFilter: this.props.updateSubFilter, clearAll: this.props.clearAll })),
            React.createElement(Accordian, { header: "Sort", content: React.createElement("div", { className: "acrd-list" }, sortList) }),
            React.createElement(Accordian, { header: "Type", content: React.createElement("div", { className: "acrd-list" }, typeList) }),
            varietalAccord,
            countryAccord,
            regionAccord,
            vintageAccord));
    }
}
;
//# sourceMappingURL=mobile-filter.js.map